import React from "react";
import { RichText } from "prismic-reactjs";
import NotFound from "../NotFound";
import Loader from "../Loader";
import FocusAreas from "../FocusAreas";
import Newsletter from "../Newsletter";
import PostItem from "../PostItem";
import Banners from "../Banners";
import { connect } from "react-redux";
import { fetchHomePage, fetchResources, fetchNews } from "../../store/actions";
import { linkResolver } from "../../prismic-configuration";

class Home extends React.Component {
  componentDidMount() {
    this.props.fetchHomePage();
    this.props.fetchResources({ pageSize: 1 });
    this.props.fetchNews({ pageSize: 1 });
  }

  renderLatest(list, title) {
    return (
      <div className="latest-list">
        <h2 className="text-uppercase mb-4">{title}</h2>
        {list.map((item, index) => {
          return (
            <PostItem
              item={item}
              key={index}
              prismicCtx={this.props.prismicCtx}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { home, resource, news } = this.props;

    if (home.settled && resource.settled && news.settled) {
      return (
        <div>
          <div
            className="hero-unit pb-5"
            style={{ backgroundImage: `url(${home.data.top_image.url})` }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="slogan-hero">
                    {RichText.render(home.data.slogan_hero, linkResolver)}
                  </div>
                  <a
                    href="https://www.geef.nl/en/donate?charity=8695&type=e"
                    className="btn btn-default px-5 text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ♥ Donate
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="container pt-5 pb-5 text-center">
            {RichText.render(home.data.slogan, linkResolver)}
          </div>

          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-5 mb-5 mb-lg-0 order-lg-last">
                <Banners
                  bannerLocation="home"
                  prismicCtx={this.props.prismicCtx}
                />
              </div>
              <div className="col-12 col-lg-7">
                {this.renderLatest(news.results, "Latest News")}
                {this.renderLatest(resource.results, "Latest Resources")}
              </div>
            </div>
          </div>

          <Newsletter />

          <div className="container">
            <FocusAreas prismicCtx={this.props.prismicCtx} />
          </div>
        </div>
      );
    } else if (this.props.home.rejected) {
      return <NotFound />;
    }

    return <Loader />;
  }
}

const mapStateToProps = state => ({
  home: state.home,
  resource: state.resource,
  news: state.news
});

export default connect(mapStateToProps, {
  fetchHomePage,
  fetchResources,
  fetchNews
})(Home);



// WEBPACK FOOTER //
// ./src/components/pages/Home.js